import { emitLineSignal, type LineSignalContextInput } from './lineLearningSignals'
import type { TimelineElement } from '../types/timelineElement'
import type { ChecklistItem } from '../types/schema'

const WINDOW_MS = 24 * 60 * 60 * 1000
const tracked = new Map<string, { turnId: string; context: LineSignalContextInput; expiresAt: number; emitted: boolean }>()

export const watchLineBuildOutcome = (goalId: string, turnId: string, context: LineSignalContextInput) => {
  if (!goalId || !turnId) return
  tracked.set(goalId, { turnId, context, expiresAt: Date.now() + WINDOW_MS, emitted: false })
}

export const recordLineBuildOutcome = (goalId: string, outcome: 'positive' | 'negative') => {
  const entry = tracked.get(goalId)
  if (!entry || entry.emitted || entry.expiresAt < Date.now()) return false
  entry.emitted = true
  emitLineSignal(outcome === 'positive' ? 'LAGGING_USAGE_POSITIVE' : 'LAGGING_USAGE_NEGATIVE', entry.turnId, entry.context)
  return true
}

/** Resolves a persisted checklist item to its owning goal without carrying titles into the observer. */
export const owningGoalIdForChecklist = (item: Pick<ChecklistItem, 'parentContainerId'>, elements: readonly Pick<TimelineElement, 'id' | 'type' | 'parentId'>[]) => {
  const byId = new Map(elements.map((element) => [element.id, element]))
  let current = byId.get(item.parentContainerId)
  while (current) {
    if (current.type === 'GOAL') return current.id
    current = current.parentId ? byId.get(current.parentId) : undefined
  }
  return null
}
